// extracted by mini-css-extract-plugin
module.exports = {"container-avatar":"Profile_container-avatar__Mfr4O","avatar-index":"Profile_avatar-index__XHJhi"};